import { graphql } from "react-relay";

export const QUERY = graphql`
	query emailTemplates_EmailTemplatesQuery {
		...emailTemplatesTable_EmailTemplatesListFragment
	}
`;
